import React, { FC } from 'react';

import { Link } from 'react-router-dom';

import translate from '../../../../i18n/translate';

import * as Styled from './styled';

type Props = {
  className?: string;
  url: string;
};

/**
 * Button wrapper that returns reused Button (link) with + (plus) as its content
 *
 * @param props           The props passed to the component
 * @param props.className styled-components generated class name, needed for styling
 * @param props.url       URL we want to navigate to
 * @returns               The component itself
 */
const ButtonAdd: FC<Props> = ({ className, url }) => {
  return (
    <Styled.ButtonAdd
      className={className}
      fontSize="large"
      forwardedAs={Link}
      iconColor="inherit"
      iconName="add"
      label={translate('GENERAL__ADD')}
      to={url}
    />
  );
};

export default ButtonAdd;
